'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './e-form-editor.routes';

export class EFormEditorComponent {
  constructor($stateParams, $scope, dialogs, EFormsService, $state, CommunityService, PropertyService) {
    'ngInject';
    this.eFormId = $stateParams.id;
    this.$scope = $scope;
    this.$state = $state;
    this.dialogs = dialogs;
    this.EFormsService = EFormsService;
    this.PropertyService = PropertyService;

    CommunityService.query(data => {
      this.communities = data.map(community => {
        return {
          value: community._id,
          name: community.code + ": " + community.name
        }
      });
    });

    this.fieldTypes = ["text","textbox","number","yes/no","select","image","help","recipient","unit"];
    this.prefillTypes = [{
      type: "name:first",
      name: "First Name",
      group: "Name"
    },{
      type: "name:last",
      name: "Last Name",
      group: "Name"
    }, {
      type: "name:full",
      name: "Full Name",
      group: "Name"
    }, {
      type: "profile:email",
      name: "Email",
      group: "Profile"
    }, {
      type: "profile:phone",
      name: "Phone",
      group: "Profile"
    }, {
      type: "profile:address",
      name: "Address",
      group: "Profile"
    }, {
      type: "date:shortDate",
      name: "Short Date (e.g. 9/6/18)",
      group: "Date and Time"
    },{
      type: "date:mediumDate",
      name: "Medium Date (e.g. Sep 6, 2018)",
      group: "Date and Time"
    },{
      type: "date:longDate",
      name: "Long Date (e.g. September 6, 2018)",
      group: "Date and Time"
    },{
      type: "date:fullDate",
      name: "Full Date (e.g. Thursday, September 6, 2018)",
      group: "Date and Time"
    }, {
      type: "date:short",
      name: "Date and Time (e.g. 9/6/18 9:02 AM)",
      group: "Date and Time"
    }];

    this.toolbarDefinition = [
      ["bold","italics","underline"],
      ["h3","h4","h5"],
      ["p","clear"],
      ["ul","ol"],
      ["archiveImageLink", "insertImage","insertLink"],
      ["html"]
    ];

    this.sortableOptions = {
      handle: '.handle'
    };

    this.fields = [];
    this.form  = ['*'];
    this.model = {};
    this.recipients = "";

    this.eForm = {
      formSchema: {
        "type": "object",
        "properties": {}
      }
    };

    if (this.eFormId) {
      this.EFormsService.get({id: this.eFormId}, eForm => {
        this.eForm = eForm;
        this.recipients = angular.isArray(eForm.recipients) ? eForm.recipients.join("\n") : '';
        this.createFields();
      })
    }

  }

/*
  updateEmailFields() {
    this.emailFields.splice(0, this.emailFields.length);
    this.emailFields.push({
      value: null,
      name: "-None-"
    });

    this.fields.filter(field => field.type == 'email').forEach(field => {

    })
  }
*/

  deleteField($event, field, idx) {
    $event.stopPropagation();

    var dlg = this.dialogs.confirm("Delete Field?", "Do you really want to delete the field '" + field.title + "'?");
    dlg.result.then(() => {
      this.fields.splice(idx,1);
    }, () => {
      // Cancel
    });

  }

  setUnitsAsEnum(field) {
    this.PropertyService.getByCommunity({communityId: field.communityId}, data => {
      field.enum = data
        .filter(ppty => ppty.lotNo)
        .map(ppty => ppty.lotNo)
        .sort((a,b) =>  a.localeCompare(b));
    })
  }

  createFields() {
    this.fields = [];

    let keys = Object.keys(this.eForm.formSchema.properties);
    let requiredFields = this.eForm.formSchema.required || [];

    keys.forEach(key => {
      let oSchemaField = this.eForm.formSchema.properties[key];

      let fieldDef = {
        key: key,
        title: oSchemaField.title || '',
        description: oSchemaField.description || '',
        required: requiredFields.indexOf(key) !== -1
      };

      switch (oSchemaField.type) {
        case 'string':
          if (oSchemaField.enum) {
            if (oSchemaField.recipient) {
              fieldDef.type = 'recipient';
            } else if (oSchemaField.communityId) {
              fieldDef.type = 'unit';
              fieldDef.communityId  = oSchemaField.communityId;
              fieldDef.copyToPrimaryOwner = oSchemaField.copyToPrimaryOwner;
            } else {
              fieldDef.type = 'select';
            }
            fieldDef.enum = oSchemaField.enum;
          } else if (oSchemaField["x-schema-form"] ) {

            if (oSchemaField["x-schema-form"]["type"] == 'textarea') {
              fieldDef.type = 'textbox';
            } else if (oSchemaField["x-schema-form"]["type"] == 'help') {
              fieldDef.type = 'help';
              fieldDef.helpvalue = oSchemaField["x-schema-form"]["helpvalue"];
            } else {
              fieldDef.type = 'text';
            }

          } else {
            fieldDef.type = 'text';
          }
          break;
        case 'number':
          fieldDef.type = 'number';
          break;
        case 'boolean':
          fieldDef.type = 'yes/no';
          break;
        case 'array':
          fieldDef.type = 'image';
          break;
      }

      if (oSchemaField["x-prefilled"]) {
        fieldDef.prefill = true;
        fieldDef.prefilled = oSchemaField["x-prefilled"];
      }

      this.fields.push(fieldDef);
    });
  }

  removeChoice(field, idx) {
    field.enum.splice(idx,1);
  }

  addChoice(field) {
    if (!field.hasOwnProperty("enum")) {
      field.enum = [""];
    } else {
      field.enum.push("");
    }
  }

  preview() {
    this.eForm.formSchema.properties = {};
    this.eForm.formSchema.required = [];

    let recipientGroups = [];

    this.recipients.split("\n").forEach(recipient => {
      // email@domain.tld|Group Name
      let splitted = recipient.split("|");
      if (splitted.length == 2) {
        let groupName = splitted[1].trim();
       if (!recipientGroups.includes(groupName)) {
         recipientGroups.push(groupName);
       }
      }
    });

    this.fields.forEach(field => {

      let fieldDef = {
        title: field.title,
        key: field.key,
        description: field.description
      };

      if (field.required && field.type != 'help') {
        this.eForm.formSchema.required.push(field.key);
      }

      switch (field.type) {
        case 'text':
          fieldDef.type = 'string';
          if (field.prefill && field.prefilled) {
            fieldDef["x-prefilled"] = field.prefilled;
          }
          break;
        case 'textbox':
          fieldDef.type = 'string';
          fieldDef["x-schema-form"] = {
            "type": "textarea"
          };
          if (field.prefill && field.prefilled) {
            fieldDef["x-prefilled"] = field.prefilled;
          }
          break;
        case 'number':
          fieldDef.type = 'number';
          break;
        case 'yes/no':
          fieldDef.type = 'boolean';
          break;
        case 'select':
          fieldDef.type = 'string';
          fieldDef.enum = field.enum || [];
          fieldDef["x-schema-form"] = {
            "placeholder": "- Select -"
          };
          break;
        case 'image':
          fieldDef.type = 'array';
          fieldDef.format = 'singlefile';
          fieldDef.pattern = {
            "mimeType": "image/*"
          };
          fieldDef["x-schema-form"] = {
            "type":     "nwpFileUpload",
            "endpoint": "/api/storage"
          };
          break;
        case 'help':
          fieldDef.type = 'string';
          fieldDef["x-schema-form"] = {
            "type": "help",
            "helpvalue": field.helpvalue
          };
          break;
        case 'recipient':
          fieldDef.type = 'string';
          fieldDef.recipient = true;
          fieldDef.enum = recipientGroups || [];
          fieldDef["x-schema-form"] = {
            "placeholder": "- Select -"
          };
          break;
        case 'unit':
          fieldDef.type = 'string';
          fieldDef.communityId = field.communityId;
          fieldDef.copyToPrimaryOwner = field.copyToPrimaryOwner;
          fieldDef.enum = field.enum || [];
          fieldDef["x-schema-form"] = {
            "placeholder": "- Select -"
          };
          break;
      }

      this.eForm.formSchema.properties[field.key] = fieldDef;
    });

    this.$scope.$broadcast('schemaFormRedraw');
  }

  addField() {
    let idx = this.fields.length+1;
    this.fields.push({
      key: 'field' + idx,
      title: 'Field ' + idx,
      type: 'text'
    })
  }


  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = data => {
        var actionString = (this.eFormId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "Your eForm has been "+actionString+" successfully");
        dlg.result.then(() => {
            that.$state.go("e-form-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.preview();

      var lines = this.recipients.split(/\n/);
      this.eForm.recipients = [];
      for (let i=0; i < lines.length; i++) {
        // only push this line if it contains a non whitespace character.
        if (/\S/.test(lines[i])) {
          this.eForm.recipients.push(lines[i].trim());
        }
      }

      this.eForm.fields = this.fields;

      if (this.eFormId) {  // Save changes on the current image gallery
        this.EFormsService.update({id: this.eFormId}, this.eForm, onSuccess, onError);
      } else { // Create a new image gallery
        this.EFormsService.save(this.eForm, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.eForms.editor', [uiRouter])
  .config(routes)
  .component('eFormEdit', {
    template: require('./e-form-editor.html'),
    controller: EFormEditorComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/e-form/edit/e-form-editor.component.js